<!-- Modal Backdrop -->
<div
  class="modal fade"
  [class.show]="isOpen()"
  [style.display]="isOpen() ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2">
          <i class="bi bi-tools"></i>
          {{ getModalTitle() }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
          [disabled]="isProcessing()"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <!-- Drone Info -->
          <div class="alert alert-light mb-4" *ngIf="droneName">
            <small class="text-muted">Drone:</small>
            <span class="fw-medium ms-2">{{ droneName }}</span>
          </div>

          <div class="row g-3">
            <!-- Type -->
            <div class="col-md-6">
              <label for="type" class="form-label">
                Type <span class="text-danger">*</span>
              </label>
              <select
                id="type"
                class="form-select"
                formControlName="type"
                [class.is-invalid]="isFieldInvalid('type')"
              >
                <option *ngFor="let opt of typeOptions" [value]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
              <div class="invalid-feedback">Type is required</div>
            </div>

            <!-- Status -->
            <div class="col-md-6">
              <label for="status" class="form-label">
                Status <span class="text-danger">*</span>
              </label>
              <select
                id="status"
                class="form-select"
                formControlName="status"
                [class.is-invalid]="isFieldInvalid('status')"
              >
                <option *ngFor="let opt of statusOptions" [value]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
              <div class="invalid-feedback">Status is required</div>
            </div>

            <!-- Title -->
            <div class="col-12">
              <label for="title" class="form-label">
                Title <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                id="title"
                class="form-control"
                formControlName="title"
                placeholder="e.g., Annual Inspection, Motor Replacement"
                [class.is-invalid]="isFieldInvalid('title')"
              >
              <div class="invalid-feedback">Title is required (minimum 3 characters)</div>
            </div>

            <!-- Description -->
            <div class="col-12">
              <label for="description" class="form-label">Description</label>
              <textarea appCharCounter
                id="description"
                class="form-control"
                formControlName="description"
                rows="2"
                placeholder="Describe the maintenance work..."
              ></textarea>
            </div>

            <!-- Scheduled Date -->
            <div class="col-md-6">
              <label for="scheduledDate" class="form-label">
                Scheduled Date <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                id="scheduledDate"
                class="form-control"
                formControlName="scheduledDate"
                [class.is-invalid]="isFieldInvalid('scheduledDate')"
              >
              <div class="invalid-feedback">Scheduled date is required</div>
            </div>

            <!-- Completed Date -->
            <div class="col-md-6">
              <label for="completedDate" class="form-label">Completed Date</label>
              <input
                type="date"
                id="completedDate"
                class="form-control"
                formControlName="completedDate"
              >
            </div>

            <!-- Performed By -->
            <div class="col-md-6">
              <label for="performedBy" class="form-label">Performed By</label>
              <input
                type="text"
                id="performedBy"
                class="form-control"
                formControlName="performedBy"
                placeholder="e.g., ADN Service Center, In-house"
              >
            </div>

            <!-- Cost -->
            <div class="col-md-6">
              <label for="cost" class="form-label">Cost ($)</label>
              <div class="input-group">
                <span class="input-group-text">$</span>
                <input
                  type="number"
                  id="cost"
                  class="form-control"
                  formControlName="cost"
                  placeholder="0.00"
                  min="0"
                  step="0.01"
                >
              </div>
            </div>

            <!-- Notes -->
            <div class="col-12">
              <label for="notes" class="form-label">Notes</label>
              <textarea appCharCounter
                id="notes"
                class="form-control"
                formControlName="notes"
                rows="2"
                placeholder="Additional notes or observations..."
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="close()"
          [disabled]="isProcessing()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onSubmit()"
          [disabled]="isProcessing() || form.invalid"
        >
          <span *ngIf="isProcessing()" class="spinner-border spinner-border-sm me-1" role="status"></span>
          {{ isEditMode() ? 'Update' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop Overlay -->
<div
  class="modal-backdrop fade"
  [class.show]="isOpen()"
  *ngIf="isOpen()"
></div>
